import Section from '../../layout/Section';
import { Col } from 'react-bootstrap';
import classes from './AboutTheProject.module.css';
import Accordion from 'react-bootstrap/Accordion';
import Link from '../Link';

const AboutTheProject = () => {
  const NounsLink = (
    <Link text="Nouns" url="https://nouns.wtf/" leavesPage={true} />
  );
  return (
    <Section bgColor="white" fullWidth={false}>
      <Col lg={{ span: 10, offset: 1 }}>
        <div className={classes.headerWrapper}>
          <h1>About the project</h1>
          <p>Bitstrays is an unmaintained tribute to onchain art. Inspired by {NounsLink} and the CC0 movement,
            every Bitstray exists entirely on Ethereum—no external dependencies, no APIs that can break.
            This project is for those who believe NFTs should outlive their creators.</p>
          <p>The smart contracts are immutable. The art is stored onchain.
            No team is required to keep the lights on—the Ethereum network is the infrastructure, and it runs forever.</p>
        </div>
        <Accordion flush defaultActiveKey="0">
          <Accordion.Item eventKey="0" className={classes.accordionItem}>
            <Accordion.Header className={classes.accordionHeader}>Summary</Accordion.Header>
            <Accordion.Body>
              <ul>
                <li>10,000 unique onchain avatars (0-9999)</li>
                <li>100% onchain: pixel art and metadata stored directly on Ethereum</li>
                <li>Generative traits determined by block hashes at mint time</li>
                <li>CC0 (public domain)—use however you want, forever</li>
                <li>No dependencies on external servers, IPFS, or APIs</li>
              </ul>
            </Accordion.Body>
          </Accordion.Item>
          <Accordion.Item eventKey="1" className={classes.accordionItem}>
            <Accordion.Header className={classes.accordionHeader}>Bitstray Traits</Accordion.Header>
            <Accordion.Body>
              <p>
                Bitstrays are generated randomly based on Ethereum block hashes.
                Each Bitstray has a 'kind' trait which is derived
                from the head. All traits are equally likely except for some rarer
                heads.<br />
                We have the following traits:
              </p>
              <ul>
                <li>arms (4) </li>
                <li>backgrounds (6) </li>
                <li>eyes (41)</li>
                <li>heads (113) </li>
                <li>motives (67) </li>
                <li>mouths (20)</li>
                <li>shirt (11)</li>
              </ul>
              There are 273,161,680 possible Bitstray combinations excluding background colors.
              Each mint permanently inscribes a unique combination into Ethereum's history.
            </Accordion.Body>
          </Accordion.Item>
        </Accordion>
      </Col>
    </Section>
  );
};
export default AboutTheProject;
